//var url_shop= "pkrct.myshopify.com";

// var url_shop=Shopify.shop;
// if(url_shop == "pkrct123123.myshopify.com" || url_shop == "rockycttest123.myshopify.com" || url_shop == "akcttest123.myshopify.com" || url_shop == "rockyct.myshopify.com" )
// {
// 	var SITE_LINK="http://localhost:3000/quizz_latest";
// }else{
// 	if(url_shop == "pkrct4545.myshopify.com" || url_shop == "learning-devraj.myshopify.com"  || url_shop == "rockycttest0123.myshopify.com" || url_shop == "akcttest.myshopify.com" || url_shop == "rockyct123.myshopify.com")
// 	{
//     var SITE_LINK = "https://apps.codetasker.com/php/quiz_app";
// 	}
// 	else
// 	{
//     var SITE_LINK = "https://quiz.moxiebeauty.in/quiz_app";
// 	}
	
// }
var SITE_LINK = "https://quiz.moxiebeauty.in/quiz_app";
var url_shop = 'moxiebeauty-haircare.myshopify.com';
//document.addEventListener("DOMContentLoaded", function() {
    // Create the question div
  //   var questionDiv = document.createElement("div");
  //   questionDiv.setAttribute("id", "question");
  //   questionDiv.setAttribute("data-id", "");
  //   questionDiv.setAttribute("data-check-id", "0");

  //   // Create the options div
  //   var optionsDiv = document.createElement("div");
  //   optionsDiv.setAttribute("id", "quiz_options");

  //   var nextDiv = document.createElement("div");
  //   nextDiv.setAttribute("id", "next");

  //   // Append the divs to the body or any desired parent element
  //   // document.body.appendChild(questionDiv);
  //   // document.body.appendChild(optionsDiv);
  //   // document.body.appendChild(nextDiv);
  //   // document.body.prepend(optionsDiv);
  //   // const sectionElement = document.getElementById('shopify-section-template--15647198412852__image_banner');
  //   // const sectionElement = document.getElementById('shopify-section-template--15647198412852__featured_collection');
  //   const sectionElement = document.getElementById('MainContent');
  // sectionElement.prepend(optionsDiv);
  //   optionsDiv.appendChild(questionDiv);
  //   optionsDiv.appendChild(nextDiv);
    
  //});





 // debugger;
window.onload = function() {
    var page = __st['p'];
    if(page == 'product'){
      function getParameter(p){
          var url = window.location.search.substring(1);
          var varUrl = url.split('&');
          for (var i = 0; i < varUrl.length; i++){
              var parameter = varUrl[i].split('=');
              if(parameter[0] == p){
                  return parameter[1];
              }
          }
      }
  
      //clickmail_analytics();
    }
    var questionIndex = 0; // Track the current question index
    
    // Function to show the next question
    function showNextQuestion() {
      var questionWrappers = document.getElementsByClassName('questionWrapper');
      document.querySelector('#preButton').style.display = '';
      var progressBar = document.getElementById("myBar");
      var progressBar_count = document.querySelector(".dev_count");
      var data_count = document.querySelector('.count_que').getAttribute("data-count");
      document.getElementById("nextButton").classList.add("btn-next");
      document.getElementById("preButton").classList.remove("btn-previous");

      var progressparentdiv = document.querySelector(".count_que");

      document.getElementById("preButton").removeAttribute("disabled");
      document.getElementById("nextButton").disabled = true;

      // Hide the current question
      questionWrappers[questionIndex].style.display = 'none';
      questionWrappers[questionIndex].closest('.questionWrapper').classList.remove('active');
      //questionWrappers[questionIndex].closest('.pro_tip_buttn').classList.add('active');

      let element = document.getElementById("question");
      element.setAttribute("data-check-id",0);
  
      // Increment the question index
      questionIndex++;

      // Check if there are more questions
      if (questionIndex < questionWrappers.length) {
        // Show the next question
        questionWrappers[questionIndex].style.display = 'block';
        questionWrappers[questionIndex].classList.add('active');

        var check_select_ans = document.querySelectorAll(".questionWrapper.active .dev_select_ans.active");
        if (check_select_ans[0] != undefined) {
          document.getElementById("nextButton").removeAttribute("disabled");
          document.getElementById("nextButton").classList.remove("btn-next");
        }

        // Detect the device's screen width
        var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        if (screenWidth <= 360) {
          // For mobile devices
          var left = ((questionIndex + 1) / questionWrappers.length) * 100;
          var width = ((questionIndex + 1) / questionWrappers.length) * 100;
          if((questionIndex + 1) - questionWrappers.length == 0)
          {
            var left = ((questionIndex + 1) / questionWrappers.length) * 100;
            //document.querySelector("#quiz_options").setAttribute("class", "");
          }
        }
        else if(screenWidth <= 360 || screenWidth <= 550){
            
          //var per=100/questionWrappers.length;
          var per=100/questionWrappers.length;
          var left = ((questionIndex + 1) / questionWrappers.length) * 100;

          //var left = per;
          
          var tt = per;
          //alert(left);
          //var left = ((questionIndex + 1) / questionWrappers.length) * 95.20;
          var width = ((questionIndex + 1) / questionWrappers.length) * 100;
          if((questionIndex + 1) - questionWrappers.length == 0)
          {
            var left = ((questionIndex + 1) / questionWrappers.length) * 100;
            //document.querySelector("#quiz_options").setAttribute("class", "");
            
          }
        }
        else {
          var left = ((questionIndex + 1) / questionWrappers.length) * 100;
          var width = ((questionIndex + 1) / questionWrappers.length) * 100;
          if((questionIndex + 1) - questionWrappers.length == 0)
          {
            var left = ((questionIndex + 1) / questionWrappers.length) * 100;
             //document.querySelector("#quiz_options").setAttribute("class", "");
          }
        }
        
        progressBar.style.width = width + "%";
        progressBar_count.style.left = left + "%";
        progressparentdiv.textContent = questionIndex + 1 + '/'+ data_count;

        // Hide or show the submit button
        document.querySelector('#submitbtn').style.display = 'none';
      } else {
        // Hide or show the submit button
        document.querySelector('#submitbtn').style.display = 'block';
        document.querySelector('#nextButton').style.display = 'none';
        document.querySelector('#preButton').style.display = 'none';
        document.querySelector('#myProgress').style.display = 'none';
        document.querySelector('.dev_footer').style.display = 'none';
        document.getElementById("quiz_options").classList.remove("Active");
        document.getElementById("quiz_options").classList.add("ct-get-email");
        document.body.classList.remove("ct-stop-scroll");
      }
    }

    // Function to show the prev question
    function showPrevQuestion() {
      var questionWrappers = document.getElementsByClassName('questionWrapper');
      var progressBar = document.getElementById("myBar");
      var progressBar_count = document.querySelector(".dev_count");
      var data_count = document.querySelector('.count_que').getAttribute("data-count");

      var progressparentdiv = document.querySelector(".count_que");
    
      // Hide the current question
      questionWrappers[questionIndex].style.display = 'none';
      questionWrappers[questionIndex].closest('.questionWrapper').classList.remove('active');
    
      let element = document.getElementById("question");
      element.setAttribute("data-check-id", 0);
    
      // Decrement the question index
      questionIndex--;
    
      // Check if there are previous questions
      if (questionIndex >= 0) {
        // Show the previous question
        questionWrappers[questionIndex].style.display = 'block';
        questionWrappers[questionIndex].classList.add('active');
        
        // var left = ((questionIndex + 1) / questionWrappers.length) * 88.4;
        // var width = ((questionIndex + 1) / questionWrappers.length) * 100;
        // progressBar.style.width = width + "%";
        // progressBar_count.style.left = left + "%";
        //progressBar.innerHTML = Math.round(width) + "%";

        // Detect the device's screen width
        var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        
        if (screenWidth <= 360) {
          // For mobile devices
          var left = ((questionIndex + 1) / questionWrappers.length) * 100;
          var width = ((questionIndex + 1) / questionWrappers.length) * 100;
        }else if (screenWidth <= 360 || screenWidth <= 550) {
          // For mobile devices
          var left = ((questionIndex + 1) / questionWrappers.length) * 100;
          var width = ((questionIndex + 1) / questionWrappers.length) * 100;
        }
        else {
          // var left = ((questionIndex + 1) / questionWrappers.length) * 100;
          // var width = ((questionIndex + 1) / questionWrappers.length) * 100;
          //   if(questionIndex == 0)
          //   {
          //     var left = 24;
          //   }
          var left = ((questionIndex + 1) / questionWrappers.length) * 100;
          var width = ((questionIndex + 1) / questionWrappers.length) * 100;
          if((questionIndex + 1) - questionWrappers.length == 0)
          {
            var left = ((questionIndex + 1) / questionWrappers.length) * 100;
          }
        }

        progressBar.style.width = width + "%";
        progressBar_count.style.left = left + "%";

        progressparentdiv.textContent = questionIndex + 1 + '/' + data_count;
        // Hide or show the submit button
        document.querySelector('#submitbtn').style.display = 'none';
        document.getElementById("nextButton").removeAttribute("disabled");
        document.getElementById("nextButton").classList.remove("btn-next");
        //document.querySelector('#nextButton').style.display = 'block';
        if (questionIndex == 0) {
          document.getElementById("preButton").disabled = true;
          document.getElementById("preButton").classList.add("btn-previous");
        }
      
      } else {
        console.log("Beginning of Questions!");
      }
    }


  
    // Function to handle the radio button click event
    var selectedAnswers = [];
    function handleRadioButtonClick() {
      var selectedValue = this.value;
      document.getElementById("nextButton").classList.remove("btn-next");
     // var selectedValue=  document.querySelector('input[name="accounts"]:checked').value;
     var data_check = document.querySelector('#question').getAttribute("data-check-id");

     var data_check_not_sure = document.querySelector('.questionWrapper.active .mybutton').getAttribute("data-check");
     let element = document.getElementById("question");
     var data = document.querySelector('#question').getAttribute("data-id");
     var que_id = document.querySelector('.questionWrapper.active .mybutton').getAttribute("id");
     document.getElementById("nextButton").removeAttribute("disabled");
      // Check if the question ID already exists in the selectedAnswers array
      var existingAnswerIndex = selectedAnswers.findIndex(function(answer) {
        return Object.keys(answer)[0] === que_id;
      });
      
      if (data_check_not_sure == 0) {   
        if (existingAnswerIndex > -1) {
          // Update the value of the existing answer
          selectedAnswers[existingAnswerIndex][que_id] = selectedValue;
        } else {
          // Add a new answer to the array
          selectedAnswers.push({ [que_id]: selectedValue });
          //selectedAnswers[que_id]=selectedValue;
        }
        element.setAttribute("data-id",JSON.stringify(selectedAnswers));
      }

       // Add "active" class to the selected answer
      var radioButtons = document.querySelectorAll('.questionWrapper.active input[type="radio"]');
      for (var i = 0; i < radioButtons.length; i++) {
        var radioButton = radioButtons[i];
        if (radioButton.value === selectedValue) {
          radioButton.closest(".dev_select_ans").classList.add("active");
        } else {
          radioButton.closest(".dev_select_ans").classList.remove("active");
        }
      }
     // showNextQuestion();
    }
  
    // Function to handle the image button click event
    function handleImageButtonClick() {
      var selectedValue = this.getAttribute("value");
      document.getElementById("nextButton").classList.remove("btn-next");

      var data_check = document.querySelector('#question').getAttribute("data-check-id");
      var data = document.querySelector('#question').getAttribute("data-id");
      let element = document.getElementById("question");
      document.getElementById("nextButton").removeAttribute("disabled");
      var data_check_not_sure = document.querySelector('.questionWrapper.active .mybutton').getAttribute("data-check");
      var que_id = document.querySelector('.questionWrapper.active .mybutton').getAttribute("id");

      // Check if the question ID already exists in the selectedAnswers array
      var existingAnswerIndex = selectedAnswers.findIndex(function(answer) {
        return Object.keys(answer)[0] === que_id;
      });

      if (data_check_not_sure == 0) {   
        if (existingAnswerIndex > -1) {
          // Update the value of the existing answer
          selectedAnswers[existingAnswerIndex][que_id] = selectedValue;
        } else {
          // Add a new answer to the array
          selectedAnswers.push({ [que_id]: selectedValue });
          //selectedAnswers[que_id]=selectedValue;
        }
        element.setAttribute("data-id",JSON.stringify(selectedAnswers));
         // Add the "active" class to the clicked button
        var buttons = document.querySelectorAll('.questionWrapper.active .mybutton .dev_select_ans');
        buttons.forEach(function(button) {
          if (button.getAttribute("value") === selectedValue) {
           button.classList.add("active");
            //button.closest(".dev_img_ans").classList.add("active");
          } else {
            button.classList.remove("active");
          }
        });
      }else{
        var buttons = document.querySelectorAll('.questionWrapper.active .mybutton .dev_select_ans');
        buttons.forEach(function(button) {
          if (button.getAttribute("value") === selectedValue) {
           button.classList.add("active");
            //button.closest(".dev_img_ans").classList.add("active");
          } else {
            button.classList.remove("active");
          }
        });
      }
     // showNextQuestion();
    }

    
  
    // Function to handle the next button click event
    function handleNextButtonClick() {
      showNextQuestion();     
    }

    function handleprevButtonClick(){
      showPrevQuestion();
    }

    function handletakeButtonClick(){
      document.querySelector('.dev_wel_popup').style.display = 'none';
      document.querySelector('.questionWrapper.active').style.display = 'block';
      const main_div_reveclass = document.getElementById('quiz_options');
      main_div_reveclass.setAttribute("class", "Active");  
      // document.querySelector('body').setAttribute("class", "ct-stop-scroll")  
      document.body.classList.add("ct-stop-scroll");
      document.querySelector('#nextButton').style.display = '';
      document.querySelector('#myProgress').style.display = 'block';
      document.querySelector('#preButton').style.display = '';
      document.querySelector('.dev_footer').style.display = 'block';
      
    }  

    function handleprotipButtonClick(){
      const proTipButtons = document.querySelectorAll('.pro_tip_buttn');
      proTipButtons.forEach(button => button.style.display = '');
    }
    
    function handlecloseprotipButtonClick(){
      const proTipButtons = document.querySelectorAll('.pro_tip_buttn');
      proTipButtons.forEach(button => button.style.display = 'none');
    }

//     function initComparisons() {
//       var x, i;
//       /*find all elements with an "overlay" class:*/
//       x = document.getElementsByClassName("img-comp-overlay");
//       // x = document.getElementsByClassName("img-comp-container");
//       for (i = 0; i < x.length; i++) {
//           /*once for each "overlay" element:
//           pass the "overlay" element as a parameter when executing the compareImages function:*/
//           compareImages(x[i]);
//       }
//       function compareImages(img) {
//           var slider, img, clicked = 0, w, h;
//           /*get the width and height of the img element*/
//           w = img.offsetWidth;
//           h = img.offsetHeight;
//           /*set the width of the img element to 50%:*/
//           img.style.width = (w / 2) + "px";
//           /*create slider:*/
//           slider = document.createElement("DIV");
//           slider.setAttribute("class", "img-comp-slider");
//           /*insert slider*/
//           img.parentElement.insertBefore(slider, img);
//           /*position the slider in the middle:*/
//           slider.style.top = (h / 2) - (slider.offsetHeight / 2) + "px";
//           slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";
//           /*execute a function when the mouse button is pressed:*/
//           slider.addEventListener("mousedown", slideReady);
//           /*and another function when the mouse button is released:*/
//           window.addEventListener("mouseup", slideFinish);
//           /*or touched (for touch screens:*/
//           slider.addEventListener("touchstart", slideReady);
//           /*and released (for touch screens:*/
//           window.addEventListener("touchend", slideFinish);
//           function slideReady(e) {
//               /*prevent any other actions that may occur when moving over the image:*/
//               e.preventDefault();
//               /*the slider is now clicked and ready to move:*/
//               clicked = 1;
//               /*execute a function when the slider is moved:*/
//               window.addEventListener("mousemove", slideMove);
//               window.addEventListener("touchmove", slideMove);
//           }
//           function slideFinish() {
//               /*the slider is no longer clicked:*/
//               clicked = 0;
//           }
//           function slideMove(e) {
//               var pos;
//               /*if the slider is no longer clicked, exit this function:*/
//               if (clicked == 0) return false;
//               /*get the cursor's x position:*/
//               pos = getCursorPos(e)
//               /*prevent the slider from being positioned outside the image:*/
//               if (pos < 0) pos = 0;
//               if (pos > w) pos = w;
//               /*execute a function that will resize the overlay image according to the cursor:*/
//               slide(pos);
//           }
//           function getCursorPos(e) {
//               var a, x = 0;
//               e = (e.changedTouches) ? e.changedTouches[0] : e;
//               /*get the x positions of the image:*/
//               a = img.getBoundingClientRect();
//               /*calculate the cursor's x coordinate, relative to the image:*/
//               x = e.pageX - a.left;
//               /*consider any page scrolling:*/
//               x = x - window.pageXOffset;
//               return x;
//           }
//           function slide(x) {
//               /*resize the image:*/
//               img.style.width = x + "px";
//               /*position the slider:*/
//               slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
//           }
//       }
//   }
// ////////////////////////////////////////////////////// End Product compare image  JS


////////////////////////////////////////////////////// Product compare image  JS
// function initComparisons() {
//   var x, i;
//   /*find all elements with an "overlay" class:*/
//   x = document.getElementsByClassName("img-comp-overlay");
//   for (i = 0; i < x.length; i++) {
//       /*once for each "overlay" element:
//       pass the "overlay" element as a parameter when executing the compareImages function:*/
//       compareImages(x[i]);
//   }
//   function compareImages(img) {
//       var slider, img, clicked = 0, w, h;
//       /*get the width and height of the img element*/
//       w = img.offsetWidth;
//       h = img.offsetHeight;
//       /*set the width of the img element to 50%:*/
//       img.style.width = (w / 2) + "px";
//       /*create slider:*/
//       slider = document.createElement("DIV");
//       slider.setAttribute("class", "img-comp-slider");
//       /*insert slider*/
//       img.parentElement.insertBefore(slider, img);
//       /*position the slider in the middle:*/
//       slider.style.top = (h / 2) - (slider.offsetHeight / 2) + "px";
//       slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";
//       /*execute a function when the mouse button is pressed:*/
//       slider.addEventListener("mousedown", slideReady);
//       /*and another function when the mouse button is released:*/
//       window.addEventListener("mouseup", slideFinish);
//       /*or touched (for touch screens:*/
//       slider.addEventListener("touchstart", slideReady);
//       /*and released (for touch screens:*/
//       window.addEventListener("touchend", slideFinish);
//       function slideReady(e) {
//           /*prevent any other actions that may occur when moving over the image:*/
//           e.preventDefault();
//           /*the slider is now clicked and ready to move:*/
//           clicked = 1;
//           /*execute a function when the slider is moved:*/
//           window.addEventListener("mousemove", slideMove);
//           window.addEventListener("touchmove", slideMove);
//       }
//       function slideFinish() {
//           /*the slider is no longer clicked:*/
//           clicked = 0;
//       }
//       function slideMove(e) {
//           var pos;
//           /*if the slider is no longer clicked, exit this function:*/
//           if (clicked == 0) return false;
//           /*get the cursor's x position:*/
//           pos = getCursorPos(e)
//           /*prevent the slider from being positioned outside the image:*/
//           if (pos < 0) pos = 0;
//           if (pos > w) pos = w;
//           /*execute a function that will resize the overlay image according to the cursor:*/
//           slide(pos);
//       }
//       function getCursorPos(e) {
//           var a, x = 0;
//           e = (e.changedTouches) ? e.changedTouches[0] : e;
//           /*get the x positions of the image:*/
//           a = img.getBoundingClientRect();
//           /*calculate the cursor's x coordinate, relative to the image:*/
//           x = e.pageX - a.left;
//           /*consider any page scrolling:*/
//           x = x - window.pageXOffset;
//           return x;
//       }
//       function slide(x) {
//           /*resize the image:*/
//           img.style.width = x + "px";
//           /*position the slider:*/
//           slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
//       }
//   }
// }
////////////////////////////////////////////////////// End Product compare image  JS


    
    function submit_email(){	
      document.querySelector('body').classList.remove("class", "ct-stop-scroll")
      var email=document.querySelector('.quiz_notify_email').value;
      var ans_arr = document.querySelector('#question').getAttribute("data-id");
      var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;		
      e_flag=0;
      if(email != ""){
        if(!regex.test(email)) {			
        document.querySelector('.error_msg').style.display = 'block';
        document.querySelector('.quiz_notify_email').classList.add('error');
        e_flag=1;
        }
        else{
        document.querySelector('.quiz_notify_email').classList.remove('error');
        document.querySelector('.ttct_email, .error_msg').style.display = 'block';
        e_flag=0;
        }
      }
      else{
        document.querySelector('.quiz_notify_email').classList.add('error');
        document.querySelector('.error_msg').style.display = 'block';
        e_flag=1;
      }

      if(e_flag == 0){
        document.querySelector('.dev_loader').style.display = 'block';
         document.querySelector('.hair-routine.result-page .hair-routine-inner').style.display = 'none';
       
        document.querySelector('.error_msg').style.display = 'none';
        document.querySelector('.dev_email_hide').style.display = 'none';

        setTimeout(function(){
          var data={
            "shop_url": url_shop,
            "email":email,
            "ans_arr":ans_arr,
            "method_call":"get_result"
          }
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
              if (this.readyState == 4 && this.status == 200) {
                var response = JSON.parse(this.response);
                if(response.success == "true"){
                  document.querySelector('.dev_loader').style.display = 'none';
                  document.querySelector('#submitbtn').style.display = 'none';
                  document.getElementById("quiz_options").classList.remove("ct-get-email");
                  document.getElementById("quiz_options").classList.add("ct-onresult-page");
                  document.getElementById("next").innerHTML += response.body; 
  
                  var classname = document.getElementsByClassName("dev_add_cart");
                  for (var i = 0; i < classname.length; i++) {                                
                      classname[i].addEventListener("click", myFunction);
                  }

                  (function($) {
                    class BeforeAfterSlider extends HTMLElement {
                        constructor() {
                            super();
                
                            this.active = false;
                            this.touch = undefined;
                            this.button = $(this).find('.before-after-slider__button');
                            this.init();
                        }
                
                        init() {
                            this.button.on('touchstart mousedown', this.startEvent.bind(this));
                            $(document.body).on('touchend mouseup', this.endEvent.bind(this));
                            $(document.body).on('touchmove mousemove', this.bindEvent.bind(this));
                        }
                
                        startEvent() {
                            this.active = true;
                            $(this).addClass('is-scrolling');
                        }
                
                        endEvent() {
                            this.active = false;
                            $(this).removeClass('is-scrolling');
                        }
                
                        bindEvent(event) {
                            if (!this.active) return;
                
                            if (event.type === 'touchmove') {
                                this.touch = event.changedTouches[0];
                            }
                            let posX = event.pageX || this.touch.pageX;
                
                            const min = 20;
                            const box = $(this).get(0).getBoundingClientRect();
                            const { left, width } = box;
                            const delta = posX - left;
                
                            let percent = (delta / width) * 100;
                            const minPercent = (min / width) * 100;
                
                            if (percent < minPercent)  percent = minPercent;
                            if (percent > 100 - minPercent)  percent = 100 - minPercent;
                            $(this).css('--percent', `${percent}%`);
                        }
                    }
                
                    customElements.define('before-after-slider', BeforeAfterSlider);
                })(jQuery);

                  var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                  var viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                  
                  if (screenWidth <= 360 || screenWidth <= 550) {
                    

                  }
                  else {
                     var fix_product_inner = new Swiper(".fix-product-inner", {
                        slidesPerView: "auto",
                        spaceBetween: 30, 
                        navigation: {
                          nextEl: ".swiper-button-next",
                          prevEl: ".swiper-button-prev",
                        },
                       breakpoints: {
                        1050: {
                          slidesPerView: "auto",
                          spaceBetween: 30,
                        },
                        740: {
                          slidesPerView: "auto",
                          spaceBetween: 30,
                        },
                      }
                      });
                     
                  }


                  var products_sliderCCC = new Swiper(".products_sliderCCC", {
                      slidesPerView: "auto",
                      spaceBetween: 10,
                      pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                      },
                      navigation: {
                          nextEl: ".swiper-button-next",
                          prevEl: ".swiper-button-prev",
                      },
                      breakpoints: {
                        1050: {
                          slidesPerView: 4,
                          spaceBetween: 30,
                        },
                        740: {
                          slidesPerView: 2.2,
                          spaceBetween: 30,
                        },
                    }
                    });

                  var swiper = new Swiper(".dev_bundle_products", {
                    slidesPerView: 1,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                      },
                    navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    },
                  }); 
                }
              }
            }
            request.open('POST', SITE_LINK+"/front_data/front_call.php", true);
            request.send(JSON.stringify(data));
       },5000);
      }
    }

  
   // function myFunction() {      
   //    // var variant_id;
   //      variant_id=this.getAttribute('data-id');                                      
   //      let formData = {
   //          'items': [{
   //              'id': variant_id,
   //              'quantity': 1,
   //              "properties":{                                                    
   //                  "__quiz": "ct-quiz"
   //                  }
   //              }]
   //          };
   //          fetch('/cart/add.js', {
   //          method: 'POST',
   //          headers: {
   //              'Content-Type': 'application/json'
   //          },
   //          body: JSON.stringify(formData)         
   //          })
   //          .then(response => {
   //            fetch(`${routes.cart_url}`)
   //            .then((response) => response.text())
   //            .then((responseText) => {
   //                 var productsHtml = $(responseText).find('.cart-drawer'); 
   //                  $(".drawer").html(productsHtml);
   //                  $(".drawer").removeClass('is-empty');
   //                  $(".drawer").addClass('animate active');
   //              //   var newCount = parseInt(jQuery('.cart-count-bubble span').text()) + 1;
   //              // jQuery('.cart-count-bubble span').text(newCount);
   //                  var s= parseInt(jQuery('.cart-count-bubble span:first').text());
   //                  var f=s+1;
   //                  jQuery('.cart-count-bubble span').text(f);

   //            })
             
   //          })
   //          .catch((error) => {                                            
   //          });
   //  }



function myFunction() {
    var variant_id = this.getAttribute('data-id');
    let formData = {
        'items': [{
            'id': variant_id,
            'quantity': 1,
            "properties": {
                "__quiz": "ct-quiz"
            }
        }]
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        updateCartUI();
        checkForFreeGift(); // Check for a free gift after adding the item.
    })
    .catch((error) => {
        console.error('Error adding item to cart:', error);
    });
}

function updateCartUI() {
    fetch(`${routes.cart_url}`)
    .then(response => response.text())
    .then(responseText => {
        var productsHtml = $(responseText).find('.cart-drawer');
        $(".drawer").html(productsHtml);
        $(".drawer").removeClass('is-empty').addClass('animate active');

        var newCount = parseInt(jQuery('.cart-count-bubble span:first').text()) + 1;
        jQuery('.cart-count-bubble span').text(newCount);
    })
    .catch(error => console.error('Error updating cart UI:', error));
}

function checkForFreeGift() {
    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(cart => {
        var total_price = cart.total_price / 100; // Convert to actual price if needed.

        if (total_price >= 999) {
            // Assuming 'id' in cart.attributes is meant to track the free gift's presence.
            // Change '47243158683970' to your free gift's variant ID.
            const freeGiftVariantId = "47243158683970";
            const hasFreeGift = cart.items.some(item => item.id.toString() === freeGiftVariantId);

            if (!hasFreeGift) {
                addFreeGift(freeGiftVariantId);
            }
        } else {
            // Handle case if total_price is under threshold and a free gift exists.
        }
    })
    .catch(error => console.error('Error checking for free gift:', error));
}

function addFreeGift(variantId) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items: [{
                id: variantId,
                quantity: 1
            }]
        })
    })
    .then(response => {
        console.log('Free gift added to cart.');
        updateCartUI(); // Optionally update the cart UI again to show the free gift.
    })
    .catch(error => console.error('Error adding free gift to cart:', error));
}







//var price;                                
    // function myFunction() {      
    //   // var variant_id;
    //   //if (!customElements.get('product-form')) {
    //   // customElements.define('product-form', class ProductForm extends HTMLElement {
    //  const uniqueIdentifier = Math.random().toString(36).substring(7);
    //    //customElements.define('product-form',class ProductForm extends HTMLElement { 
    //    customElements.define(`product-form-${uniqueIdentifier}`, class ProductForm extends HTMLElement {
    //     constructor() {
    //       super();
    
    //       this.form = this.querySelector('form');
    //       this.form.querySelector('[name=id]').disabled = false;
    //       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    //       this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    //       this.submitButton = this.querySelector('[type="submit"]');
    //       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    
    //       this.hideErrors = this.dataset.hideErrors === 'true';
    //     }
    
    //     onSubmitHandler(evt) {
    //       alert("dfdfdf");
    //       evt.preventDefault();
    //       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    
    //       this.handleErrorMessage();
    
    //       this.submitButton.setAttribute('aria-disabled', true);
    //       this.submitButton.classList.add('loading');
    //       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    
    //       const config = fetchConfig('javascript');
    //       config.headers['X-Requested-With'] = 'XMLHttpRequest';
    //       delete config.headers['Content-Type'];
    
    //       const formData = new FormData(this.form);
    //       if (this.cart) {
    //         formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
    //         formData.append('sections_url', window.location.pathname);
    //         this.cart.setActiveElement(document.activeElement);
    //       }
    //       config.body = formData;
          
    //       fetch(`${routes.cart_add_url}`, config)
    //         .then((response) => response.json())
    //         .then((response) => {
    //           alert(response)
    //           console.log(response);
              
    //           if (response.status) {
                
    //             publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
    //             this.handleErrorMessage(response.description);
    
    //             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
    //             if (!soldOutMessage) return;
    //             this.submitButton.setAttribute('aria-disabled', true);
    //             this.error = true;
    //             return;
    //           } else if (!this.cart) {
                
    //             window.location = window.routes.cart_url;
    //             return;
    //           }
    
    //           if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
    //           this.error = false;
    //           const quickAddModal = this.closest('quick-add-modal');
    //           if (quickAddModal) {
    //             document.body.addEventListener('modalClosed', () => {
    //               setTimeout(() => { this.cart.renderContents(response) });
    //             }, { once: true });
    //             quickAddModal.hide(true);
    //           } else {
                
    //             var $this=this;
    //             console.log(response);
    //              $this.cart.renderContents(response);
    //             console.log(response);   
               
    //           }
              
    //         })
    //         .catch((e) => {
    //           console.error(e);
    //         })
    //         .finally(() => {
    //           //alert("dfdf");
    //           this.submitButton.classList.remove('loading');
    //           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    //            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
               
    //         });
    //     }
    
    //     handleErrorMessage(errorMessage = false) {
    //       if (this.hideErrors) return;
    
    //       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    //       if (!this.errorMessageWrapper) return;
    //       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    
    //       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    
    //       if (errorMessage) {
    //         this.errorMessage.textContent = errorMessage;
    //       }
    //     }
    //   });

    // }

    // Send an AJAX request to get the questions
    var page_check = __st['p'];
  var pageurl_check = __st['pageurl'];
  if (pageurl_check == 'moxiebeauty.in/pages/hair-quiz') {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var questionDiv = document.createElement("div");
      questionDiv.setAttribute("id", "question");
      questionDiv.setAttribute("data-id", "");
      questionDiv.setAttribute("data-check-id", "0");
  
      // Create the options div
      var optionsDiv = document.createElement("div");
      optionsDiv.setAttribute("id", "quiz_options");

      var footerdiv = document.createElement("div");
      footerdiv.setAttribute("id", "dev_footer_main");
  
      var nextDiv = document.createElement("div");
      nextDiv.setAttribute("id", "next");

       var cartpopup = document.getElementsByClassName('dev_cart_popup_search');
        if (cartpopup.length >= 0 && cartpopup.length < 1) {
            var newDiv = document.createElement('div');
            newDiv.setAttribute("class", "dev_cart_popup_search");
            document.body.appendChild(newDiv);
        }
      // Append the divs to the body or any desired parent element
      // document.body.appendChild(questionDiv);
      // document.body.appendChild(optionsDiv);
      // document.body.appendChild(nextDiv);
      // document.body.prepend(optionsDiv);
      // const sectionElement = document.getElementById('shopify-section-template--15647198412852__image_banner');
      //const sectionElement = document.getElementById('shopify-section-template--15647198412852__featured_collection');
      const sectionElement = document.getElementById('MainContent');
      sectionElement.prepend(optionsDiv);
      optionsDiv.appendChild(questionDiv);
      optionsDiv.appendChild(footerdiv);
      optionsDiv.appendChild(nextDiv);

      //}
      //xhr.onreadystatechange = function() {
        if(page_check == 'product'){
          var id = getParameter('id');
          var pn_id_em = getParameter('pn_id');
          var v_id_em = getParameter('v_id');
        }
      if (this.readyState === 4 && this.status === 200) {
        var key_val = JSON.parse(this.responseText);
        var key_val_mail = JSON.parse(this.responseText);
        if (key_val.success == "true") {
          
          if (key_val_mail.wel_status == 0) {
            const main_div = document.getElementById('quiz_options');
            main_div.setAttribute("class", "active");  
          }


          //console.log( key_val.body);
          document.getElementById("question").innerHTML = key_val.body;
          document.getElementById("next").innerHTML += key_val.submit;
         document.getElementById("dev_footer_main").innerHTML += key_val.next;
         // document.getElementById("next").innerHTML += key_val.prev;
         //document.getElementById("next").innerHTML += key_val.progress;
         
         // Get all the radio buttons
         var radioButtons = document.getElementsByName("accounts");
         
         // Add event listener to each radio button
         radioButtons.forEach(function(radioButton) {
           radioButton.addEventListener("click", handleRadioButtonClick);
          });
          
          // Get all the image buttons
          var imgbtn = document.querySelectorAll(".dev_img_ans.dev_select_ans");
          
          // Add event listener to each image button
          imgbtn.forEach(function(imgbtn) {
            imgbtn.addEventListener("click", handleImageButtonClick);
          });
          
          // Hide all the question wrappers except the first one
          var questionWrappers = document.getElementsByClassName('questionWrapper');
          for (var i = 0; i < questionWrappers.length; i++) {
            questionWrappers[i].style.display = 'none';
          }
          
          // take quiz button js
          document.getElementById("takebtn").addEventListener("click", handletakeButtonClick);
          
          // Hide the submit button initially
          document.querySelector('#submitbtn').style.display = 'none';
  
  
          // Add event listener to the next button
          document.getElementById("nextButton").addEventListener("click", handleNextButtonClick);

          // Add event listener to the prev button
          document.getElementById("preButton").addEventListener("click", handleprevButtonClick);

          document.querySelector(".dev_quiz_submit .email_submit_button").addEventListener("click", submit_email);

          // Add event listener to the pro tip button
          // document.querySelectorAll(".protip_Button").addEventListener("click", handleprotipButtonClick);

          // Add event listener to the pro tip close button
          //document.querySelector(".close_pro_tip_buttn").addEventListener("click", handlecloseprotipButtonClick);

             var protipButtons = document.querySelectorAll(".protip_Button");
  
             // Add event listener to each radio button
             protipButtons.forEach(function(protipButtons) {
              protipButtons.addEventListener("click", handleprotipButtonClick);
             });

             var protipButtons_close = document.querySelectorAll(".close_pro_tip_buttn");
  
             // Add event listener to each radio button
             protipButtons_close.forEach(function(protipButtonsclose) {
              protipButtonsclose.addEventListener("click", handlecloseprotipButtonClick);
             });

            
               // Uncomment these lines
              
                // Swiper initialization code here
                  var swiper = new Swiper(".banner_slider", {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,                    
                    navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    },
                  });   

                  if(page == 'product'){
                    //clickmail_analytics();
                    console.log("product page");
                    if (typeof id != "undefined"){
                      var decode_id = atob(id);
                      var pn_id= atob(pn_id_em);	
                      var v_id= atob(v_id_em);
    
                      var data={	    		
                        "shop_url":url_shop,
                        "id":pn_id,
                        "shop_id":decode_id,		
                        "method_call":"click_email"
                      }	
                      //
                      //console.log(data);
                      xhr.open("POST", SITE_LINK+'/front_data/front_call.php', false);
                      xhr.send(JSON.stringify(data));	

                     // console.log(v_id);
                     //  console.log("mail redirect");
                      
                      if (this.readyState === 4 && this.status === 200) {
                        var key_val_mail = JSON.parse(this.responseText);
                        console.log(key_val_mail.mail_success);
                        
                        if(key_val_mail.mail_success !== "true"){

                          // fetch('/cart/update.js', {
                          //     method: "POST",
                          //     headers: {
                          //         'X-Requested-With': 'XMLHttpRequest',
                          //         'Content-Type': 'application/json;'
                          //     },
                          //     body: JSON.stringify({
                          //         attributes: {
                          //             __quiz: v_id
                          //         }
                          //     })
                          // }).then(response => {
                          //     let formData = {
                          //         'items': [{
                          //           'id': v_id,
                          //           'quantity': 1,
                          //           "properties":{                                                    
                          //               "__quiz": "ct-quiz"
                          //               }
                          //         }]
                          //       };
                          //     fetch(window.Shopify.routes.root + 'cart/add.js', {
                          //         method: 'POST',
                          //         headers: {
                          //         'Content-Type': 'application/json'
                          //         },
                          //         body: JSON.stringify(formData)
                          //     })
                          //     .then(response => {
                          //         window.location.href='/checkout';
                          //         return response.json();
                          //     })
                          //     .catch((error) => {
                          //         console.error('Error:', error);
                          //     });
                          //     return response.json();
                          // })
                          // .catch((error) => {
                          //     console.error('Error:', error);
                          // });
                         // console.log("ddd");
                          //alert(v_id);

                          // fetch('/cart/update.js', {
                          //   method: "POST",
                          //   headers: {
                          //     'X-Requested-With': 'XMLHttpRequest',
                          //     'Content-Type': 'application/json;'
                          //   },
                          //   body: JSON.stringify({
                          //     attributes: {
                          //       notify: product_variant_id
                                
                          //     }
                          //   })
                          // }).then(response => {
                              let formData = {
                                'items': [{
                                  'id': v_id,
                                  'quantity': 1,
                                  "properties":{                                                    
                                      "__quiz": "ct-quiz"
                                      }
                                }]
                              };
                            fetch(window.Shopify.routes.root + 'cart/add.js', {
                              method: 'POST',
                              headers: {
                              'Content-Type': 'application/json'
                              },
                              body: JSON.stringify(formData)
                            })
                            .then(response => {
                              window.location.href='/checkout';
                              return response.json();
                            })
                            .catch((error) => {
                              console.error('Error:', error);
                            });
                            return response.json();
                          // })
                          // .catch((error) => {
                          //   console.error('Error:', error);
                          // });
                        }
                      }

                    }
                  }
              
        }
      }
    }
    var data = {
      "shop_url": url_shop,
      "method_call": "get_question"
    };
    xhr.open("POST", SITE_LINK + '/front_data/front_call.php', true);
    xhr.send(JSON.stringify(data));
  }


    // var page_name = __st['p'];
    //   var xhrs = new XMLHttpRequest();
    //   xhrs.onload = function () {
    //       var id = getParameter('id');
    //       var pn_id_em = getParameter('pn_id');
    //     if (this.readyState === 4 && this.status === 200) {
    //       var key_val = JSON.parse(this.responseText);
    //       if (key_val.success == "true") {
    //         // if(page == 'product'){
    //           //clickmail_analytics();
    //           if (typeof id !== "undefined"){
    //             var decode_id = atob(id);
    //             var pn_id= atob(pn_id_em);	
    //             //alert(pn_id);
                            
    //             var data_email={	    		
    //               "shop_url":url_shop,
    //               "id":pn_id,
    //               "shop_id":decode_id,		
    //               "method_call":"click_email"
    //             }	
    
    //             // console.log(data);
        
    //             xhrs.open("POST", SITE_LINK+'/front_data/front_call.php', true);
    //             xhrs.send(JSON.stringify(data_email));	
    //           }
    //         // }
                
    //       }
    //     }
    //   }

    // console.log(data);

    // xhrs.open("POST", SITE_LINK+'/front_data/front_call.php', true);
    // xhrs.send(JSON.stringify(data_email));	
    // var data = {
    //   "shop_url": url_shop,
    //   "method_call": "get_question"
    // };
    // xhr.open("POST", SITE_LINK + '/front_data/front_call.php', true);
    // xhr.send(JSON.stringify(data));
};



